export default "__VITE_ASSET__1b260de5__"